import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';

import ModalRow from '@web/timeClock/modals/rows/ModalRow/ModalRow';
import PositionIconSvg from '@web/assets/svg/Icons/32/position-gray.svg';

type Props = {
  position: {
    name: string;
    color: string;
  };
};

const PositionRow = ({ position }: Props) => (
  <ModalRow label={gettext('Position')} icon={PositionIconSvg}>
    <Text14 color={position.color}>{position.name}</Text14>
  </ModalRow>
);

export default PositionRow;
